import { Routes, Route } from 'react-router-dom';

import LoginContainer from './login/Login.container';
import PasswordResetContainer from './password-reset/PasswordReset.container';
import RecoverPasswordContainer from './recover-password/RecoverPassword.container';
import SignUpContainer from './sign-up/SignUp.container';
import KeycloakRegistrationContainer from './keycloak-registration/KeycloakRegistration.container';
import DeleteAccountContainer from './delete-account/DeleteAccount.container';

const AuthContainer = () => (
  <Routes>
    <Route path="/" element={<LoginContainer />} />
    <Route path="/sign-up" element={<SignUpContainer />} />
    <Route path="/reset-password" element={<PasswordResetContainer />} />
    <Route path="/recover-password" element={<RecoverPasswordContainer />} />
    <Route path="/user-registration/:personExternalReference" element={<KeycloakRegistrationContainer />} />
    <Route path="/remove-account" element={<DeleteAccountContainer />} />
  </Routes>
);

export default AuthContainer;
